import { format } from "date-fns"

import { Botao, Cores, Corpo, Icone, Modal, Titulo } from "@componentes-mu/componentes-mu"

import { HistoricoAtendimento } from "../../../types/atendimentos/historico/types"
import { ReleasedVersion } from "../../../types/cliente/versoes/types"
import styles from './styles.module.scss'
import { FlexRow } from "../../../components/Flex"

export type HistoricoModalProps = {
    showModal: boolean
    onClose: () => void
    historico: HistoricoAtendimento[]
    releasedVersion: ReleasedVersion
}

export const HistoricoModal = ({ showModal, onClose, historico, releasedVersion }: HistoricoModalProps) => {
    return (
        <Modal
            isOpen={showModal}
            onClose={onClose}
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                width: "100%",
                height: "100%",
            }}
        >
            <div className={styles.modalContent}>
                <FlexRow justifyContent="space-between" style={{ marginBottom: 16 }}>
                    <Titulo tipo="cabecalho2" negrito >Histórico de Atendimento - {releasedVersion.numFicha}</Titulo>
                    <Botao onClick={onClose} cor={Cores.MensagensDoSistema.VermelhoADMU}>
                        <Icone nome={"close"} cor="#FDFDFD" />
                    </Botao>
                </FlexRow>

                {historico.length === 0 ? (
                    <Corpo tipo="body2" cor={Cores.GradacaoNeutros.CinzaFillMU600}>Nenhum histórico disponível.</Corpo>
                ) : (
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        {historico.map(({ oid, data, situacao, descricao }) => (
                            <li
                                key={oid}
                                style={{
                                    marginBottom: 16,
                                    borderBottom: "1px solid #eee",
                                    paddingBottom: 12,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                }}
                            >
                                <div style={{ display: "flex", gap: 32, justifyContent: "flex-start", alignItems: "center" }}>
                                    <div>
                                        <strong>Data:</strong> {format(new Date(data), 'dd/MM/yyyy')}
                                    </div>
                                    <div>
                                        <strong>Situação:</strong> {situacao}
                                    </div>
                                </div>
                                <div>
                                    <strong>Descrição:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: descricao }} />
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </Modal>
    );
};